import { bindable } from 'aurelia-framework';

export class BusyIndicator {
	@bindable active: boolean = false;
	@bindable label: string;
	@bindable size: string = "big";
}
